import { campaignJoinDimensions, campaignJoinTimeDimensions, meetingBodyJoinDimensions, seatJoinDimensions, } from './shared-dimensions.js';
import { seatTermStatusValueLabels } from './value-labels.js';
/**
 * Combination data source: Seats x Campaigns x Applications.
 * Links vacant seats to active recruitment efforts and incoming applications.
 */
export const seatRecruitmentCube = {
    category: 'Recruitment',
    description: 'Vacant seats linked to active recruitment campaigns and incoming applications.',
    label: 'Seat Recruitment & Vacancies',
    requiredModule: 'hasTenure',
    // Measures are inherited from `meeting_body_seat_terms` in Cube.js (avg/min days_remaining)
    // and defined directly in the seat_recruitment cube (application sums), so
    // `generateMeasuresFromDimensions` does not apply here.
    measures: {
        'seat_recruitment.count': { label: 'Count', type: 'number' },
        'seat_recruitment.avg_days_remaining': { label: 'Avg Days Remaining', type: 'number' },
        'seat_recruitment.min_days_remaining': { label: 'Min Days Remaining', type: 'number' },
        'seat_recruitment.total_active_applications': {
            label: 'Total Applications In Progress',
            type: 'number',
        },
        'seat_recruitment.total_all_applications': {
            label: 'Total Applications Received',
            type: 'number',
        },
    },
    dimensions: {
        // Term
        'seat_recruitment.active_applications': { label: 'Applications In Progress', type: 'number' },
        'seat_recruitment.has_campaign': { label: 'Has Campaign', type: 'boolean' },
        'seat_recruitment.is_current': { label: 'Term Is Current', type: 'boolean' },
        'seat_recruitment.status': {
            label: 'Term Status',
            type: 'string',
            valueLabels: seatTermStatusValueLabels,
        },
        'seat_recruitment.total_applications': { label: 'Applications Received', type: 'number' },
        ...meetingBodyJoinDimensions,
        ...seatJoinDimensions,
        ...campaignJoinDimensions,
    },
    timeDimensions: {
        'seat_recruitment.end_date': { label: 'Term End Date', type: 'date' },
        'seat_recruitment.start_date': { label: 'Term Start Date', type: 'date' },
        'seat_recruitment.vacancy_date': { label: 'Term Vacancy Date', type: 'date' },
        ...campaignJoinTimeDimensions,
    },
};
